import { useCallback } from 'react';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import useTakerMarkets, { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';

// TODO: remove MarketLayoutOutletContext after PendingMarketHistory and MarketHistory are removed
export interface MarketLayoutOutletContext {
  readonly takerMarket: TakerMarket;
  readonly urlParams: {
    marketId: string;
    takerId: number;
  };
}

export function useMarketLayoutOutletContext() {
  return useOutletContext<MarketLayoutOutletContext>();
}

const MarketRedirect = () => {
  const params = useParams<{ marketId: string; takerId: string }>();
  const location = useLocation();
  const { marketId = '', takerId: takerIdParam = '' } = params;
  const takerId = parseInt(takerIdParam);
  const { data: takerMarket } = useTakerMarkets(
    useCallback(
      (takerMarkets: TakerMarket[]) => {
        if (isNaN(takerId)) {
          return;
        }

        return takerMarkets.find((tm) => tm.marketId === marketId && tm.takerDivisionId === takerId);
      },
      [marketId, takerId]
    )
  );

  const requestedPath = location.pathname.split('/enterprise/supplier/').join('');

  if (!marketId || !takerId || !takerMarket || !requestedPath) {
    return <NavigateWithRedirect to={asEnterpriseLink('customers')} />;
  }

  return (
    <NavigateWithRedirect to={asEnterpriseLink(`customers/${takerMarket.makerOrganizationUuid}/${requestedPath}`)} />
  );
};

export default MarketRedirect;
